import { TmBaseError } from '@/core/error/tmBaseError'

export class TmGoogleServicesError extends TmBaseError {
  public name = 'TmGoogleServicesError'
}
